import { DataProvider, IScreenModel, ITextComponentModel } from "@nf/common";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { firstValueFrom } from "rxjs";

import type { ICommonProps } from "helpers/getCommonServerSideProps";
import NotAvailableScreen, {
  type NotAvailableComponent,
  type NotAvailableScreenProps,
} from "screens/NotAvailableScreen";
import { CUSTOM_PAGE_ID } from "@nf/common/src/providers/DataProvider/RedBeeMedia/constants";

export const getServerSideProps: GetServerSideProps<
  NotAvailableScreenProps & ICommonProps
> = async (ctx) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );

  const { commonProps } = await getCommonServerSideProps(ctx);

  const { setCacheHeader } = await import("helpers/cacheHeaderHelper");

  setCacheHeader(ctx.res);

  let screen: IScreenModel = {};

  try {
    screen = await firstValueFrom(
      DataProvider.getScreenComponentBody(CUSTOM_PAGE_ID.NOT_AVAILABLE)
    );
  } catch (e) {
    console.log(
      `Error while fetching ${CUSTOM_PAGE_ID.NOT_AVAILABLE} screen data`,
      e
    );
  }

  return {
    props: {
      component: (screen?.Components?.[0] as ITextComponentModel)
        ?.TextParsed as NotAvailableComponent,
      ...commonProps,
    },
  };
};

const NotAvailablePage = (props: NotAvailableScreenProps) => {
  return <NotAvailableScreen {...props} />;
};

NotAvailablePage.getLayout = function getLayout(page: ReactElement) {
  return page;
};

export default NotAvailablePage;
